import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { SITE } from '@/lib/site'

interface State {
  hasError: boolean
}

/**
 * Sem isto, um erro de render em qualquer ponto da árvore apaga a página
 * inteira — inclusive o cabeçalho e o rodapé — e a pessoa fica com uma tela
 * branca sem explicação. Aqui o erro fica contido e ainda sobra um caminho de
 * volta e o endereço de suporte.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Erro inesperado na interface', error, info.componentStack)
  }

  override render(): ReactNode {
    if (!this.state.hasError) return this.props.children

    return (
      <div className="container-page py-20 text-center">
        <h1 className="text-2xl font-bold">Algo deu errado nesta tela</h1>
        <p className="mx-auto mt-2 max-w-md text-muted-foreground">
          Recarregue a página para tentar de novo. Se continuar, escreva para{' '}
          <a href={`mailto:${SITE.supportEmail}`} className="text-brand underline">
            {SITE.supportEmail}
          </a>
          .
        </p>
        <Button className="mt-6" onClick={() => window.location.reload()}>
          Recarregar a página
        </Button>
      </div>
    )
  }
}
